/* istanbul ignore file */

import React from 'react';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import {
  ClickCarouselLinkPayload,
  PillBarCarousel,
} from '@noths/polaris-client-ribbons-design-system';
import { Link } from '@noths/polaris-dev-ts-types';

import { RELATED_CATEGORIES_TITLE } from '../constants/copy';
import { RELATED_CATEGORIES_ID } from '../constants/elementIds';
import * as styles from '../styles/LinkCarousel.styles';

export interface LinkCarouselProps {
  links: Link[];
  onCarouselVisible?: () => void;
}

export const LinkCarousel = ({ links, onCarouselVisible }: LinkCarouselProps) => {
  const handleLinkClick = (
    evt: React.MouseEvent<HTMLAnchorElement>,
    { link }: ClickCarouselLinkPayload,
  ) => {
    sendGALinkClickEvent(evt, {
      event: 'custom_event',
      event_category: 'Related Category',
      event_action: 'Link Click',
      event_label: link.title!,
    });
  };

  return links.length > 0 ? (
    <div css={styles.linkCarouselWrapper}>
      <PillBarCarousel
        onLinkClick={handleLinkClick}
        onVisible={onCarouselVisible}
        links={links}
        carouselType="related-categories"
        id={RELATED_CATEGORIES_ID}
        title={RELATED_CATEGORIES_TITLE}
      />
    </div>
  ) : null;
};
